export const ToastMessages = {
  common: {
    REQUIRED_FIELDS: 'Please fill all required fields.',
    INVALID_INPUT: 'Some fields have invalid input.',
    TRY_AGAIN: 'Something went wrong. Please try again.',
    UNEXPECTED_ERROR_TRY_AGAIN: 'Something went wrong. Please try again.',
    SOMETHING_WENT_MISSING_TRY_AGAIN:
      'Looks like something went missing. Please refresh or try again soon.',
    FAILED_TO_SAVE_CHANGES: 'Failed to save changes.',
    ERROR_OCCURRED_TRY_LATER_OR_CONTACT_ADMIN:
      'Error occurred. Try again later or contact your administrator.',
    REQUEST_COMPLETED: 'This request has already been completed.',
    PLEASE_TRY_AGAIN_AFTER_FEW_HOURS:
      'Email not arriving? Please check your spam folder or contact your administrator.',
  },

  verifyToken: {
    error: {
      INVALID_AUTHENTICATION: 'Invalid authentication request',
    },
  },
  onboarding: {
    success: {
      ONBOARDING_COMPLETED:
        'Great job! You’ve taken an important first step towards understanding your wellbeing. Keep exploring to unlock your personalised insights.',
    },
  },

  checkIn: {
    success: {
      CHECK_IN_SAVED:
        'Check-in saved! Taking a moment to reflect on your wellbeing is always worthwhile.',
    },
    error: {
      QUESTIONNAIRE_NOT_FOUND: 'Sorry, assessment not found',
      CHECK_IN_SAVE_UNSUCCESSFUL: 'Sorry, we couldn’t save your results. Please try again.',
      ANSWER_ALL_QUESTIONS: 'Please answer all questions before submitting',
    },
  },

  priorities: {
    success: {
      PRIORITIES_SAVED_SUCCESSFULLY:
        'Priorities set! You’re now focused on what matters most for you.',
    },
    info: {
      ALL_THE_AREAS_ALREADY_ADDED: 'All priorities are already added.',
    },
    error: {
      MAXIMUM_10_PRIORITIES: 'You can only select up to 10 priorities.',
      CREATE_ASSESSMENT_FIRST: 'Please create an assessment first.',
      ERROR_OCCURRED_WHEN_REMOVING: 'Sorry, an error occurred when removing priorities.',
    },
  },

  journal: {
    success: {
      REFLECTION_SAVED:
        'Your reflection is saved. Taking time to reflect supports your wellbeing journey.',
    },
    error: {
      ERROR_SUBMITTING: 'Sorry, we couldn’t save your reflection. Please try again.',
      PLEASE_ENTER_YOUR_REFLECTION: 'Please enter your reflection',
    },
  },

  questionnaireV2: {
    success: {},
    info: {},
    error: {
      QUESTIONNAIRE_IS_MISSING: 'Assessment is missing. Please try again!',
    },
  },

  talkToAdvisor: {
    success: {
      SUCCESSFULLY_SHARED: 'Your request is successfully sent.',
    },
    info: {},
    error: {
      QUESTIONNAIRE_NOT_SELECTED: 'Assessment not selected',
    },
  },

  booking: {
    success: {
      BOOKING_SUCCESSFUL:
        'Your booking is successful. Please check your email for confirmation and more information.',
    },
    info: {},
    error: {
      BOOKING_FAILED: 'Sorry, booking is failed. Please try again.',
    },
  },

  createSpeakUp: {
    success: {
      MESSAGE_SHARED_SUCCESSFULLY: 'Thank you, your message has been successfully shared.',
      YOUR_THOUGHT_SAVED: 'Your thoughts have been saved',
    },
    info: {
      PLEASE_SELECT_A_QUESTIONNAIRE: 'Please select a questionnaire',
    },
    error: {
      YOU_HAVE_EXCEEDED_YOUR_CREATE_SPEAK_UP_LIMIT:
        'We’ve received several messages from you recently and want to ensure you get the proper attention you deserve. Please allow time for your team to respond thoughtfully to your concerns. If you need urgent help, please click here to access urgent help resources.',
      QUESTIONNAIRE_AND_DESCRIPTION_REQUIRED:
        'Please write a message and select a question to share.',
      PLEASE_SELECT_QUESTION_TO_SHARE: 'Please select a question to share',
      PLEASE_ENTER_MESSAGE: 'Please enter a message',
    },
  },

  instantMessaging: {
    error: {
      WAIT_UNTIL_PREVIOUS_MESSAGE: 'Please wait until the previous message is sent.',
    },
  },

  dashboard: {
    success: {
      DATA_FETCHED: 'Your dashboard is ready to explore.',
    },
    error: {
      DATA_FETCH_FAILED:
        'We’re having trouble loading your dashboard. Please try refreshing the page.',
    },
  },

  experts: {
    success: {
      SESSION_CANCELLED: 'Your expert booking session is cancelled successfully',
      CREDIT_REQUEST_SUBMITTED: 'Expert credit request submitted',
      CREDIT_REQUEST_APPROVED: 'Credit request approved',
      CREDIT_REQUEST_REJECTED: 'Credit request rejected',
      ADMIN_CREDITS_GRANTED_SPEAKUP: 'Expert credits granted',
    },
    error: {},
    info: {},
  },

  action: {
    success: {
      ACTION_UPDATED: 'Action updated successfully.',
      ACTION_REMOVED: 'Action removed from your plan.',
      ACTION_CREATED: 'New action added to your plan.',
      ACTION_COMPLETED: 'Action completed!',
    },
    error: {},
    info: { ACTION_ALREADY_COMPLETED: 'Action already completed!' },
  },

  auth: {
    success: {
      LOGIN: 'Welcome back!',
      LOGOUT: 'See you soon!',
    },
    error: {
      LOGIN_FAILED: 'Invalid credentials.',
      UNAUTHORIZED: 'You are not authorised.',
      LOGIN_UNSUCCESSFUL_CONTACT_ADMIN:
        "We couldn't log you in. Please contact your administrator.",
      SOMETHING_WENT_WRONG_DURING_LOGIN_TRY_AGAIN:
        'Something went wrong during login. Please try again.',
    },
    info: {
      WE_COULD_NOT_RECOGNISE_THIS_EMAIL:
        "We couldn't recognise this email address. If you are new to Hapstar, click 'Sign Up' below to create your account.",
      REDIRECTING_TO_SINGLE_SIGN_ON: 'Redirecting to single sign-on...',
      EMAIL_SENT_TO_YOUR_INBOX: 'An email has been sent to your email address.',
      PLEASE_ENTER_A_VALID_EMAIL_ADDRESS: 'Please enter a valid email address.',
      PROCESSING_LOGIN_REQUEST: 'Logging you in...',
      PLEASE_ENTER_VALID_DETAILS_AND_AGREE_WITH_TERMS:
        'Please enter a valid email address, company code and agree with the terms & conditions.',
      NO_ORGANISATION_IS_AVAILABLE_FOR_THIS_COMPANY_CODE:
        'No organisation is available for this company code.',
      EMAIL_ADDRESS_IS_ALREADY_REGISTERED: 'Email address is already registered.',
      ADD_USER_UNSUCCESSFUL_CONTACT_ADMIN:
        "We couldn't create your account. Please contact your administrator.",
    },
  },

  communityFeed: {
    success: {
      POST_CREATED_SUCCESSFULLY: 'Thank you for sharing with the community.',
      REPLY_CREATED_SUCCESSFULLY: 'Thank you for contributing to the conversation.',
      POST_CREATED_SUCCESSFULLY_AND_ON_REVIEW:
        'Thank you for sharing with the community. Your post is being reviewed and will be visible soon.',
      REPLY_CREATED_SUCCESSFULLY_AND_ON_REVIEW:
        'Thank you for contributing to the conversation. Your reply is being reviewed and will be visible soon.',
      YOUR_POST_UPDATED_SUCCSSFULLY: 'Your post has been updated successfully.',
      YOUR_POST_REMOVED_SUCCSSFULLY: 'Your post has been removed.',
      YOUR_REPLY_UPDATED_SUCCSSFULLY: 'Your reply has been updated.',
      YOUR_REPLY_REMOVED_SUCCSSFULLY: 'Your reply has been removed.',
    },
    error: {},
    info: {},
  },
} as const;

export type ToastSection = keyof typeof ToastMessages;
export type ToastType<T extends ToastSection> = keyof (typeof ToastMessages)[T];
